import { jsx } from "react/jsx-runtime";
import { cva } from "../../../node_modules/class-variance-authority/dist/index.js";
import { forwardRef } from "react";
import { twMerge } from "../../../node_modules/tailwind-merge/dist/bundle-mjs.js";
const listVariants = cva(["rounded-lg py-2 empty:hidden"], {
  variants: {
    divider: {
      true: "divide-y divide-separator-color-light",
      false: ""
    },
    autoScroll: {
      true: "overflow-y-auto",
      false: ""
    }
  },
  defaultVariants: {
    divider: false,
    autoScroll: true
  }
});
const List = forwardRef((props, ref) => {
  const { children, divider, autoScroll, className, ...rest } = props;
  return /* @__PURE__ */ jsx("ul", { ...rest, ref, className: twMerge(listVariants({ divider, autoScroll, className })), children });
});
export {
  List as default
};
//# sourceMappingURL=List.js.map
